import * as React from 'react';

import { IRadioButtonProps, RadioButton } from '../RadioButton';

export interface ITypedRadioButtonProps<NameType, ValueType> extends Omit<IRadioButtonProps, 'name' | 'value'> {
  value: ValueType;
  name: NameType;
}

export function TypedRadioButton<
  NameType extends string = string,
  ValueType extends string | number | undefined = string | number | undefined,
>(props: ITypedRadioButtonProps<NameType, ValueType>) {
  return <RadioButton {...props} />;
}
